module.exports = __webpack_public_path__ + "static/media/box-data-waiting.2c893257.svg";